import { BrandDefinition } from '../brand.interface';
import { createDefaultBrandTexts, defineBrandConfig } from '../define-brand-config';
import { defineThemeVariables } from '../theme-variable';
import { logo as telepagosLogo } from './logo-base64';

const buildBrandAssetUrl = (assetPath: string): string => `assets/brands/telepagos/${assetPath}`;

const buildDefaultAssets = () => ({
  logoUrl: buildBrandAssetUrl('img/logo.png'),
  footerLogoUrl: buildBrandAssetUrl('svg/isologo-blanco.svg'),
  faviconUrl: buildBrandAssetUrl('img/favicon-32x32.png'),
  favicon16Url: buildBrandAssetUrl('img/favicon-16x16.png'),
  favicon32Url: buildBrandAssetUrl('img/favicon-32x32.png'),
});

export const telepagosBrand: BrandDefinition = {
  key: 'telepagos',
  config: defineBrandConfig({
    displayName: 'TelePagos',
    appName: 'TelePagos',
    siteTitle: 'TelePagos - Plataforma Web',
    copyrightLabel: 'TelePagos',
    assets: buildDefaultAssets(),
    links: {
      website: {
        label: 'telepagos.com.ar',
        url: 'https://www.telepagos.com.ar/',
      },
      apiDocsUrl: 'https://telepagos.com.ar/api/',
      termsUrl: 'https://telepagos.com.ar/#tyc',
      iosAppUrl: 'http://ios.telepagos.com.ar',
      androidAppUrl: 'http://android.telepagos.com.ar',
    },
    export: {
      movimientosFilePrefix: 'movimientos_telepagos',
    },
    texts: {
      ...createDefaultBrandTexts('TelePagos'),
      devicesHelpInstall:
        'Para Agregar un Nuevo Dispositivo tenés que instalar TelePagos en el mismo y loguearte con tus datos.',
      devicesHelpManage:
        'Si querés Eliminar un Dispositivo, tenés que ingresar a la aplicación de TelePagos, luego ingresar en Perfil > Configuración > Dispositivos y eliminar el/los dispositivo/s que quieras.',
      termsHelpPrefix:
        'Para ver los Términos y Condiciones de TelePagos podés ingresar a nuestro sitio web oficial haciendo',
    },
  }),
  logoBase64: telepagosLogo,
  themeVariables: defineThemeVariables({}),
};
